import aquariumImg from "../assets/aquarium.png";
import seaTripImg from "../assets/sea-trip.png";
import mediaImg from "../assets/media.png";
import dolphinWorld from "../assets/dolphin-world.jpeg";

const services = [
  {
    route: "sea-trip",
    background: seaTripImg,
    name: "sea trip",
  },
  {
    route: "grand-aquarium",
    background: aquariumImg,
    name: "grand aquarium",
  },
  {
    route: "media",
    background: mediaImg,
    name: "media",
  },
  {
    route1: "dolphin-house",
    route: "dolphin-world",
    background: dolphinWorld,
    name: "dolphin world",
  },
];

export function isServicePath(pathname) {
  return services.some((service) => {
    const routes = [service.route];
    if (service.route1) routes.push(service.route1);
    return routes.some(
      (route) =>
        pathname === `/${route}` || pathname.startsWith(`/${route}/`)
    );
  });
}

export default services;
